import { EncryptStorage } from "encrypt-storage";

// Initialize EncryptStorage with a secret key and configuration
const encryptStorage1 = new EncryptStorage("vdoaks-d--21jnaskxo212okdasdo-", {
  prefix: "jgfuygh389u9okdoadlkmzxlcqoweqow", // Prefix for keys to avoid collisions
  stateManagementUse: true, // Enable state management features
  storageType: "localStorage", // Use localStorage as the storage type
});

// Function to set an encrypted item in storage
export const setSessionItem = (key, value) => {
  return encryptStorage1.setItem(key, JSON.stringify(value)); // Serialize value to JSON before storing
};

// Function to retrieve and parse an encrypted item from storage
export const getSessionItem = (key) => {
  return JSON.parse(encryptStorage1.getItem(key) ?? null); // Parse JSON and handle null values gracefully
};